import * as React from "react";

import type { ISession } from "@mne-authentication/api";

import type { IPermission } from "./../Restriction/useRestriction";

export interface ISessionCtx {
  session: ISession | null;
  loading: boolean;
  initialized: boolean;
  checkPermission: (permission: IPermission) => Promise<boolean>;
}

const defaultContext: ISessionCtx = {
  checkPermission: () => Promise.reject(new Error("No SessionContext is set up. Throwing default error.")),
  initialized: false,
  loading: false,
  session: null,
};

export default React.createContext(defaultContext);
